export default __webpack_public_path__ + "static/media/dog.551aeeb3.jpg";